import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dntf7rsajf: FaireBrandEntity = {
  token: "b_dntf7rsajf",
  type: "brand",
  name: "OAK + ACORN",
  avatarUrl:
    "https://cdn.faire.com/fastly/059ae0aeb82ef13f3d783b0997a5cd6a8151eb59303a84e2a724b0a7fd8ef3b0.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d7ec830f520dee6e254c8c1c54dd3f9f94d6b3bb7013a7cb574786bfe882fa9f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/059ae0aeb82ef13f3d783b0997a5cd6a8151eb59303a84e2a724b0a7fd8ef3b0.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d7ec830f520dee6e254c8c1c54dd3f9f94d6b3bb7013a7cb574786bfe882fa9f.png",
  location: "Stanley, NB, CAN",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 3,
  isInsider: false,
  description: "",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:40.491Z",
    importedBy: "entity-db-cli",
  },
};
